import { createAction } from '@reduxjs/toolkit';

import * as actionTypes from './actionTypes';

/**
 * @returns {import('./types').SocketInitializeAction}
 */
export const initialize = createAction(actionTypes.SOCKET_INITIALIZED);

/**
 * @returns {import('./types').SocketSendAction}
 */
export const send = createAction(actionTypes.SOCKET_SEND, data => ({
  payload: data,
}));
